/** Modal — Radix Dialog wrapper s vizuálem podle Brief §4.8.
 *  backdrop rgba(6,9,13,0.7) blur(4px) + panel bg-elevated radius 14 shadow-pop. */

import * as Dialog from "@radix-ui/react-dialog";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
  width?: number;
  className?: string;
}

export function Modal({ open, onOpenChange, children, width = 520, className }: ModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay
          className="fixed inset-0"
          style={{
            background: "rgba(6, 9, 13, 0.7)",
            backdropFilter: "blur(4px)",
            animation: "modalFadeIn .15s ease",
            zIndex: 9000,
          }}
        />
        <Dialog.Content
          className={cn(
            "fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 outline-none",
            className,
          )}
          // Nad Leaflet (controls 800-1000) i nad mini-mapa overlay (500).
          // Tailwind z-50 = 50; explicit style = 9001.
          style={{
            width,
            maxWidth: "calc(100vw - 32px)",
            padding: 28,
            background: "var(--bg-elevated)",
            borderRadius: "var(--r-lg)",
            border: "1px solid var(--border)",
            boxShadow: "var(--shadow-pop)",
            animation: "modalFadeIn .15s ease",
            zIndex: 9001,
          }}
        >
          {children}
        </Dialog.Content>
      </Dialog.Portal>
      <style>{`@keyframes modalFadeIn { from { opacity: 0 } to { opacity: 1 } }`}</style>
    </Dialog.Root>
  );
}

export const ModalTitle = Dialog.Title;
export const ModalDescription = Dialog.Description;
export const ModalClose = Dialog.Close;
